<template>
  <b-row>
    <b-col xl="8">
      <b-img
        center
        :src="`${rootApi}drawing/getImmagine/${selectedRow}`"
        height="500px"
        style="overflow: auto"
      >
      </b-img>
    </b-col>
    <b-col xl="4" style="border-left: 1px solid #e1e1e1;">
      <b-row class="input-dims">
        <b-col cols="12" sm="12" xl="5" lg="5">
          <label>{{ uniTranslation("A (mm)") }}</label>
        </b-col>
        <b-col cols="12" sm="12" xl="7" lg="7">
          <el-input-number
            v-model="Dimensions.a"
            :precision="2"
            :step="0.01"
            :min="0.0"
            :max="9999.99"
            :controls="false"
          ></el-input-number>
        </b-col>
      </b-row>
      <b-row class="input-dims">
        <b-col cols="12" sm="12" xl="5" lg="5">
          <label>{{ uniTranslation("B (mm)") }}</label>
        </b-col>
        <b-col cols="12" sm="12" xl="7" lg="7">
          <el-input-number
            v-model="Dimensions.b"
            :precision="2"
            :step="0.01"
            :min="0.0"
            :max="9999.99"
            :controls="false"
          ></el-input-number>
        </b-col>
      </b-row>
      <b-row class="input-dims">
        <b-col cols="12" sm="12" xl="5" lg="5">
          <label>{{ uniTranslation("C (mm)") }}</label>
        </b-col>
        <b-col cols="12" sm="12" xl="7" lg="7">
          <el-input-number
            v-model="Dimensions.c"
            :precision="2"
            :step="0.01"
            :min="0.0"
            :max="9999.99"
            :controls="false"
          ></el-input-number>
        </b-col>
      </b-row>
      <b-row class="input-dims">
        <b-col cols="12" sm="12" xl="5" lg="5">
          <label>{{ uniTranslation("D (mm)") }}</label>
        </b-col>
        <b-col cols="12" sm="12" xl="7" lg="7">
          <el-input-number
            v-model="Dimensions.d"
            :precision="2"
            :step="0.01"
            :min="0.0"
            :max="9999.99"
            :controls="false"
          ></el-input-number>
        </b-col>
      </b-row>
      <b-row class="input-dims">
        <b-col cols="12" sm="12" xl="5" lg="5">
          <label>{{ uniTranslation("Fatt. Molt. PP") }}</label>
        </b-col>
        <b-col cols="12" sm="12" xl="7" lg="7">
          <el-input-number
            v-model="Dimensions.pp"
            :precision="2"
            :step="0.01"
            :min="0.001"
            :max="9999.99"
            :controls="false"
          ></el-input-number>
        </b-col>
      </b-row>
      <b-row v-show="!brazed" class="input-dims">
        <b-col cols="12" sm="12" xl="5" lg="5">
          <label>{{ uniTranslation("L (mm)") }}</label>
        </b-col>
        <b-col cols="12" sm="12" xl="7" lg="7">
          <el-input-number
            v-model="Dimensions.l"
            :precision="2"
            :step="0.01"
            :min="0.0"
            :max="9999.99"
            :controls="false"
          ></el-input-number>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import { mapActions } from "vuex";
import { InputNumber } from "element-ui";

export default {
  components: {
    "el-input-number": InputNumber
  },
  props: {
    rootApi: {
      type: String,
      required: true
    },
    selectedRow: {
      type: Number,
      required: true
    },
    brazed: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      Dimensions: {}
    };
  },
  computed: {
    saveDimensions: function() {
      var that = this;
      var obj = JSON.parse(JSON.stringify(that.Dimensions));

      obj.a = that.check(that.Dimensions.a + "");
      obj.b = that.check(that.Dimensions.b + "");
      obj.c = that.check(that.Dimensions.c + "");
      obj.d = that.check(that.Dimensions.d + "");
      obj.pp = that.check(that.Dimensions.pp + "");
      obj.l = that.check(that.Dimensions.l + "");

      return obj;
    }
  },
  mounted() {
    var that = this;

    that.loadDimensions();
  },
  methods: {
    ...mapActions("_drawingModule", ["getDimensionsAction"]),

    loadDimensions() {
      var that = this;
      that.getDimensionsAction(that.selectedRow).then(data => {
        that.Dimensions = data;

        that.Dimensions.a = parseFloat(data.a);
        that.Dimensions.b = parseFloat(data.b);
        that.Dimensions.c = parseFloat(data.c);
        that.Dimensions.d = parseFloat(data.d);
        that.Dimensions.pp = parseFloat(data.pp.replace(",", "."));
        that.Dimensions.l = parseFloat(data.l);
      });
    },
    check(val) {
      if (val + "" == "") return 1;
      if (val <= 0) return 1;
      return val;
    }
  }
};
</script>

<style lang="scss">
.input-dims {
  margin-bottom: 10px;
}
</style>
